import { Props_SnippetImageContent } from './ImageContent.props'
import { CompileHeadingToSpan, CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import { useInView } from 'react-intersection-observer'
import { useEffect, useState } from 'react'
import SnippetLink from '../Shared/Link/Link'

export const SnippetImageContent = (props: Props_SnippetImageContent) => {
    const { snippet, heading, image, content, repeatable_link, eyebrow } = props

    const classHeadingVisibility: string = heading.visibility.value ? "" : 'accessible-heading'
    const classSnippetLayout = `snippet-image-content--${snippet.layout?.value}`
    const classSnippetBackground = `snippet-image-content--${snippet.background?.value}`

    const { ref, inView } = useInView({
        threshold: 0.3,
        triggerOnce: true
    })

    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        setIsVisible(inView)
    }, [inView])

    return (
        <section
            ref={ref}
            className={`snippet-image-content ${classSnippetLayout} ${classSnippetBackground}`}
        >
            <div className="snippet-image-content__container">
                <div className={`snippet-image-content__container-image ${isVisible ? 'is-visible' : ''}`}>
                    <img
                        loading="lazy"
                        src={image.src?.value}
                        className="snippet-image-content__image"
                        height="350"
                        width="560"
                        alt={image.alt?.value ? image.alt.value : ''}
                    />
                </div>
                <div className={`snippet-image-content__container-content ${isVisible ? 'is-visible' : ''}`}>
                    <h2 className={`snippet-image-content__heading ${classHeadingVisibility}`}>{CompileHeadingToSpan(heading?.heading?.value || '')}</h2>
                    {eyebrow?.text?.value && (
                        <p className="snippet-image-content__eyebrow">{eyebrow.text.value}</p>
                    )}

                    <div className="snippet-image-content__content">
                        { CompileMarkdown(content.content?.value || '') }
                    </div>
                    <div className="snippet-image-content__link-container">
                    {repeatable_link.map((link, index) => (
                        <SnippetLink
                            key={index}
                            className="snippet-image-content__link"
                            url={link.linkHref?.value}
                            linkStyles={link.linkStyle?.value}
                            openInNewTab={link.linkTarget?.value}
                        >
                            {link.linkText?.value}
                        </SnippetLink>
                    ))}
                </div>
                </div>
            </div>
        </section>
    )
}